import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function DeviceTypeRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/device-type', component: Index, isProtected: true, permissions: ['device_type_index']},
    {path: '/device-type/create', component: Create, isProtected: true, permissions: ['device_type_create']},
    {path: '/device-type/edit/:id', component: Edit, isProtected: true, permissions: ['device_type_edit']},

  ];

  return routes;
}
